import { ProductProvider } from '@core/domain/product'

const SECTION = 'productStatementAnswers'

export default {
    data: {
        productStatementAnswerRows: [],
    },
    methods: {
        initProductStatementAnswers() {
            const product = this.getProduct()
            this.productStatementAnswerRows = product.initProductStatementAnswers()
            if (Array.isArray(this.product.productStatementAnswers)) {
                this.markProductStateSectionReady(SECTION, () => product.getProductStatementAnswersState())
            } else if (this.dirtyStateTracker) {
                this.dirtyStateTracker.remove(SECTION)
            }
        },
        changeProductStatementAnswer(change) {
            this.getProduct().changeProductStatementAnswer(change)
        },
        refreshRejectedProductStatementAnswers(productId) {
            const product = ProductProvider(productId)
            return product.refreshProductStatementAnswers().then(() => {
                if (this.isCurrentProduct(productId)) {
                    this.markProductStateSectionReady(SECTION, () => product.getProductStatementAnswersState())
                }
            })
        },
    },
}
